import { render, staticRenderFns } from "./knapsack.vue?vue&type=template&id=04086ef5&scoped=true"
import script from "./knapsack.vue?vue&type=script&lang=js"
export * from "./knapsack.vue?vue&type=script&lang=js"
import style0 from "./knapsack.vue?vue&type=style&index=0&id=04086ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04086ef5",
  null
  
)

export default component.exports